import { render, staticRenderFns } from "./HistoryEmpty.vue?vue&type=template&id=55b1d222"
import script from "./HistoryEmpty.vue?vue&type=script&setup=true&lang=ts"
export * from "./HistoryEmpty.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports